export default function MagicWandIcon({ ...props }) {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      role='img'
      aria-label='Magic wand icon'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0303 9.46967C11.7374 9.17678 11.2626 9.17678 10.9697 9.46967L8.96967 11.4697C8.82902 11.6103 8.75 11.8011 8.75 12C8.75 12.1989 8.82902 12.3897 8.96967 12.5303L18.9697 22.5303C19.2626 22.8232 19.7374 22.8232 20.0303 22.5303L22.0303 20.5303C22.3232 20.2374 22.3232 19.7626 22.0303 19.4697L12.0303 9.46967ZM12.4999 13.9392L10.5605 11.9999L11.4999 11.0605L13.4392 12.9999L12.4999 13.9392Z'
        fill={props.fill || 'white'}
      />
      <path
        d='M6.5 3.25C6.81383 3.25 7.09448 3.4454 7.20339 3.73972L7.53494 4.63573C7.76283 5.25159 8.24841 5.73717 8.86427 5.96506L9.76028 6.29661C10.0546 6.40552 10.25 6.68617 10.25 7C10.25 7.31383 10.0546 7.59448 9.76028 7.70339L8.86427 8.03494C8.24841 8.26283 7.76283 8.74841 7.53494 9.36427L7.20339 10.2603C7.09448 10.5546 6.81383 10.75 6.5 10.75C6.18617 10.75 5.90552 10.5546 5.79661 10.2603L5.46506 9.36427C5.23717 8.74841 4.75159 8.26283 4.13573 8.03494L3.23972 7.70339C2.9454 7.59448 2.75 7.31383 2.75 7C2.75 6.68617 2.9454 6.40552 3.23972 6.29661L4.13573 5.96506C4.75159 5.73717 5.23717 5.25159 5.46506 4.63573L5.79661 3.73972C5.90552 3.4454 6.18617 3.25 6.5 3.25Z'
        fill={props.fill || 'white'}
      />
      <path
        d='M17.5 1.25C17.8138 1.25 18.0945 1.4454 18.2034 1.73972L18.6455 2.93439C18.9746 3.82398 19.676 4.52537 20.5656 4.85454L21.7603 5.29661C22.0546 5.40552 22.25 5.68617 22.25 6C22.25 6.31383 22.0546 6.59448 21.7603 6.70339L20.5656 7.14546C19.676 7.47463 18.9746 8.17602 18.6455 9.06561L18.2034 10.2603C18.0945 10.5546 17.8138 10.75 17.5 10.75C17.1862 10.75 16.9055 10.5546 16.7966 10.2603L16.3545 9.06561C16.0254 8.17602 15.324 7.47463 14.4344 7.14546L13.2397 6.70339C12.9454 6.59448 12.75 6.31383 12.75 6C12.75 5.68617 12.9454 5.40552 13.2397 5.29661L14.4344 4.85454C15.324 4.52537 16.0254 3.82398 16.3545 2.93439L16.7966 1.73972C16.9055 1.4454 17.1862 1.25 17.5 1.25Z'
        fill={props.fill || 'white'}
      />
    </svg>
  )
}
